import { PermissionPolicyJson } from '~/data/workflow/permission/PermissionPolicyJson'
import { PermissionPolicy } from '~/domain/workflow/permission/PermissionPolicy'

export function mapModelToPermissionPolicyJson(
  policy: PermissionPolicy
): PermissionPolicyJson {
  return policy.name
}
